import { Button, Card } from '@aws-amplify/ui-react'
import { ReactNode } from 'react'
import { Typography } from '../FaceLiveness'
import * as S from './CustomErrorView.styled'
import { getEnv } from '../../env'
import { EVENTS, postMessageToParent } from '../../features/window-messaging'

const env = getEnv()

type Props = {
  children: ReactNode
  onRetry: VoidFunction
}

const onRetry = () => {
  postMessageToParent(EVENTS.RETRY)
}

const CustomErrorView = ({ children }: Props) => {
  return (
    <S.CardOverlay>
      <Card title="Error">
        <Typography variant="p" tag="div">
          {children}

          <S.LinkWrapper>
            Please try again or raise a{' '}
            <a href={env.REACT_APP_SUPPORT_URL} target="_blank" rel="noopener noreferrer">
              Support Ticket.
            </a>
          </S.LinkWrapper>
        </Typography>
        <Button onClick={onRetry}>Try again</Button>
      </Card>
    </S.CardOverlay>
  )
}

export default CustomErrorView
